module.exports = __webpack_public_path__ + "img/6.014e03bf.svg";